import { Lock } from "lucide-react";

import { SURFACE_LABEL, currentEnvironmentLabel } from "@/config/surface";

import { SurfaceWorkFor } from "./SurfaceWorkFor";

interface InternalSurfaceBandProps {
  /** `fixed` takes SubNavBar's slot — keep `h-10` or NavBar (`top-10`) overlaps.
   *  `static` is the flow child DashboardLayout wants. */
  position: "fixed" | "static";
  /** Off for the /work-for page, which owns the picker itself — two on one
   *  screen read as two different controls. */
  showWorkFor?: boolean;
}

// Deliberately slate + amber, NOT penn-700: that fill belongs to the customer
// surface's "Working for" banner, and two blue bands read as the same control.
export function InternalSurfaceBand({
  position,
  showWorkFor = true,
}: InternalSurfaceBandProps) {
  const environment = currentEnvironmentLabel();
  const fixed = position === "fixed";

  return (
    <div
      className={`w-full bg-slate-900 border-b border-slate-700 ${
        fixed ? "fixed top-0 z-40" : "shrink-0"
      }`}
    >
      <div className="mx-auto px-3 sm:px-6 h-10 flex items-center gap-2 sm:gap-3">
        <Lock className="w-3.5 h-3.5 shrink-0 text-amber-300" aria-hidden />
        <span className="text-xs font-semibold tracking-widest text-amber-300 whitespace-nowrap">
          {SURFACE_LABEL}
        </span>
        {environment && (
          <span className="px-1.5 py-0.5 rounded bg-amber-300 text-slate-900 text-[10px] font-bold tracking-wider whitespace-nowrap">
            {environment}
          </span>
        )}
        <span className="hidden lg:inline text-xs text-slate-400 truncate">
          PennEngineering staff tooling
        </span>
        {/* Work-For sits here rather than in the user menu so the active
            customer is visible without opening anything. */}
        {showWorkFor && (
          <div className="ml-auto flex items-center min-w-0">
            <SurfaceWorkFor />
          </div>
        )}
      </div>
    </div>
  );
}
